export enum TranslationModeEnum {
  PLACEHOLDER = 1,
  TOOLTIP = 2,
  VIEWER = 3,
  INSERT_VALUE = 4,
}
